export default __webpack_public_path__ + "static/media/senior-sample5.85486620.png";